import { Routes } from '@angular/router';

import { SupportRequestPageComponent } from './pages/support-request/support-request.page';

export const supportRoutes: Routes = [
	{
		path: '',
		component: SupportRequestPageComponent
	}
];
